function backendBase() {
  return String(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
}

export async function postTeacherApi(endpoint, adminToken, body) {
  const res = await fetch(`${backendBase()}/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${adminToken}`,
    },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
}

export function getWelcomeIdentity(user) {
  const role = user?.role || "";
  const name = String(user?.name || "").trim();
  const email = String(user?.email || "").trim();
  const isDemo = role === "demobypass" || user?.source === "DEMO";

  if (role === "GUEST_USER") {
    if (!email.includes("@")) {
      return {
        fullName: email || name || "Guest",
        nameLabel: "Employee ID",
        isDemo,
      };
    }
    return {
      fullName: email.split("@")[0],
      nameLabel: "Email ID",
      isDemo,
    };
  }

  return {
    fullName: name || "Player",
    nameLabel: "Name",
    isDemo,
  };
}
